import { MarketParticipantCheck } from '../../turboLive/dto';
import { Participant } from '../../../types/generated/nikeone';

export interface CombinableBet {
    betId: string;
    betEventId: string;
    marketId: string;
    marketTicketCombinable: boolean;
    marketGroupId: number;
    marketUniqueParticipantCheck: MarketParticipantCheck;
    marketGroupCombinationMask: number;
    tournamentAllowMarketCombinations: boolean;
    participants: Participant[];
}

export function mapCombinableLiveBets(liveBets, markets, tournamentAllowMarketCombinations) {
    return liveBets?.map(bet => {
        const market = markets.find(market => market.id === bet.marketId);
        return {
            betId: bet.id,
            betEventId: bet.matchId,
            marketId: bet.marketId?.replace(/[^0-9]/g, ''),
            marketTicketCombinable: market.marketCombinable,
            marketGroupId: market.marketGroupId,
            marketUniqueParticipantCheck: market.marketParticipantCheck,
            marketGroupCombinationMask: market.marketGroupCombinationMask,
            tournamentAllowMarketCombinations: tournamentAllowMarketCombinations,
            participants: bet.betParticipants
        } as CombinableBet;
    });
}

export function mapCombinablePrematchBets(prematchBets) {
    return prematchBets?.map(bet => {
        return {
            betId: bet.betId,
            betEventId: bet.sportEventId,
            marketId: bet.marketId,
            marketTicketCombinable: bet.combinationRules.marketCombinable,
            marketGroupId: bet.combinationRules.marketGroupId,
            marketUniqueParticipantCheck: bet.combinationRules.marketParticipantCheck,
            marketGroupCombinationMask: bet.combinationRules.marketGroupCombinationMask,
            tournamentAllowMarketCombinations: bet.combinationRules.tournamentAllowMarketCombinations,
            participants: bet.betParticipants
        } as CombinableBet;
    });
}

export function mapCombinableBetslipBets(betslipBets) {
    return betslipBets?.map(bet => {
        const jsBet = bet.toJS();
        return {
            betId: jsBet.betId?.replace(/[^0-9]/g, ''),
            betEventId: jsBet.betEventId,
            marketId: jsBet.marketId?.replace(/[^0-9]/g, ''),
            marketTicketCombinable: jsBet.marketCombinable,
            marketGroupId: jsBet.marketGroupId,
            marketUniqueParticipantCheck: jsBet.marketParticipantCheck,
            marketGroupCombinationMask: jsBet.marketGroupCombinationMask,
            tournamentAllowMarketCombinations: jsBet.tournamentAllowMarketCombinations,
            participants: jsBet.participants
        } as CombinableBet;
    });
}
